import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";

function CustomerSupport() {
  return (
    <Box className={`container`}>
      <Box
        className={styles.flexColumnCenter}
        gap={4}
        mt="40px"
        mb="67px"
        style={{ transform: isMobile ? "scale(1)" : "scale(0.92)" }}
      >
        <FeedAndChargesItem />
        <CustomerSupportItem />
      </Box>
    </Box>
  );
}

function FeedAndChargesItem() {
  return (
    <Box
      className={`${styles.blueDottedBox} ${styles.flexColumnCenter}`}
      position={"relative"}
    >
      {!isMobile && (
        <img
          src={AppIcons.icGreyCircle}
          className={styles.feesRightCircleIcon}
        />
      )}
      {!isMobile && (
        <img
          src={AppIcons.icGreyCircle}
          className={styles.feesLeftCircleIcon}
        />
      )}

      <Typography className={`${styles.loanTitle}`}>
        {Strings.FeesNCharges}
      </Typography>

      <Box className={styles.feesSeparator}>
        {/* left divider */}
        <Box className={styles.feesLeftSection}>
          <Typography className={styles.feesTitle}>
            {Strings.interestRate}
          </Typography>
          <Typography className={styles.feesDesc}>
            {Strings.reducingUpto25}
          </Typography>
        </Box>

        {/* center divider */}
        <div style={{ border: "2px solid white" }}></div>

        {/* right divider */}
        <Box className={styles.feesRightSection}>
          <Typography className={styles.feesTitle}>
            {Strings.processingFee}
          </Typography>
          <Typography className={styles.feesDesc}>
            {Strings.GSTUpto4}
          </Typography>
        </Box>
      </Box>

      <Typography className={styles.feesBottomText}>
        {Strings.plentyChargedWhenSomeoneDelays}
      </Typography>
    </Box>
  );
}

function CustomerSupportItem() {
  return (
    <Box
      className={`${styles.blueDottedBox} ${styles.flexColumnCenter}`}
      position={"relative"}
    >
      {/* title and subtitle section */}
      <Typography className={`${styles.loanTitle}`}>
        {Strings.customerSupport}
      </Typography>
      <Typography className={styles.loanDescription}>
        {Strings.weHereToHelp}
      </Typography>

      {/* contact text and banner wrapper */}
      <Box mt="6px" className={styles.contactMailWrapper}>
        {/* contact and email section */}
        <Box display={"flex"} flexDirection={"column"} gap="18px">
          <Box className={styles.contactTextWrapper}>
            <img src={AppIcons.icCall}></img>
            <Typography>{Strings.mmContactNumber}</Typography>
          </Box>
          <Box className={styles.contactTextWrapper}>
            <img src={AppIcons.icMail}></img>
            <Typography> {Strings.mmEMail}</Typography>
          </Box>
        </Box>

        {/* banner section */}
        {!isMobile && (
          <img src={AppIcons.imgCustomerSupport} width={186} height={148} />
        )}
        {!isMobile && (
          <img
            src={AppIcons.icGreyCircle}
            className={styles.contactCircleIcon}
          />
        )}
      </Box>
    </Box>
  );
}
export default CustomerSupport;
